<template>
  <div>
    <div class="row" style="height: 100vh; width: 100%;">
      <div class="col-md-8 p-0">
        <div style="background-color: white;  height: 100vh;">
          <div class="background d-flex flex-column" style="justify-content: start;">
            <div class="transbox">
              <div v-if="loading">
                <div class="text-center py-4 px-2">
                  <b-spinner class="align-middle mx-2"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </div>
              <div v-else class="d-flex flex-row px-5 py-2">
                <img :src="imageBasePath + companyLogoUrl" alt="" style="width: 15%;object-fit: contain"/>
                <p>{{ companyFullName }}</p>
              </div>
            </div>
            <div style="height: 30vh;"></div>
          </div>
        </div>

      </div>
      <div class="col-md-4 p-0 bg-white">
        <div class="px-5 py-4" style="background-color: white; height: 100vh; ">
                    <span v-if="!loading" class="d-flex flex-row align-items-center text-center"
                          style="justify-content: space-between; padding-inline: 60px;">
                        <img alt="" src="../assets/bdgovt.png" style="width: 35%; object-fit: contain;"/>
                        <img :src="imageBasePath + companyLogoUrl" alt="" style="width: 40%; object-fit: contain;"/>
                    </span>
          <div v-else>
            <b-spinner class="align-middle mx-2"></b-spinner>
          </div>
          <div style="height: 8vh;"></div>

          <div class="d-flex flex-column align-items-start">
            <div style="font-weight: 500; font-size: 16px; text-align: center;">Welcome back to our</div>
            <div style="font-weight: 600; font-size: 24px;">Content Management System!</div>
          </div>
          <div style="height: 6vh;"></div>
          <div v-if="ssoLoggingLoading">
            <div class="text-center text-primary my-2 px-2">
              <b-spinner class="align-middle mx-2"></b-spinner>
              <strong>Please wait...</strong>
            </div>
          </div>
          <form v-else class="d-flex flex-column" @submit.prevent="handleLogin1">
            <RouterLink class="align-self-end mb-2 cursor-pointer" style="margin-inline: 40px;" to="/forgot-password">
              Forgot Password
            </RouterLink>
            <div class="form-data">
              <div class="forms-inputs mb-4" style="margin-inline: 40px;">
                <span style="font-size: 14px;">USER ID</span>
                <input v-model="user.userId" :disabled="showOtpModal" autocomplete="off" class="form-control px-3"
                       style="height: 6vh;"
                       type="text"/>
              </div>
              <div class="forms-inputs mb-4" style="margin-inline: 40px;">
                <span style="font-size: 14px;">PASSWORD</span>
                <input v-model="user.password" :disabled="showOtpModal" :type="showPassword ? 'text' : 'password'"
                       autocomplete="off"
                       class="px-3" style="height: 6vh;" v-bind:class="{
                                        'form-control': true,
                                        'is-invalid':
                                            !validPassword(user.password) && passwordBlurred,
                                    }" v-on:blur="passwordBlurred = true"/>
                <div v-if="showPassword" class="password-show" role="button" @click="toggleShow">
                  <i class="fas fa-eye" style="color: grey;"></i>
                </div>
                <div v-else class="password-show" role="button" @click="toggleShow">
                  <i class="fas fa-eye-slash" style="color: grey;"></i>
                </div>
              </div>
              <div class="d-flex flex-row mb-4"
                   style="margin-inline: 40px;flex-wrap: wrap;justify-content: center;text-align: center;">
                <input v-model="termsAgreed" class="me-2" type="checkbox">
                <div>
                  I agree to the
                </div>
                <a class="px-2" style="font-weight: 600; color: purple;cursor: pointer;">
                  Terms and Conditions
                </a>
                <div>
                  and
                </div>
                <a class="px-2" style="font-weight: 600; color: purple;cursor: pointer;">
                  Privacy Policy.
                </a>
              </div>
              <div style="height: 4vh;"></div>
              <div v-if="showOtpModal" class="mb-4 text-center">
                {{ otpPhoneMessage }}
              </div>
              <div v-if="showOtpModal" class="forms-inputs mb-4" style="margin-inline: 40px;">
                <span class="startColor requiredMark" style="font-size: 14px;">OTP*</span>
                <input id="name" v-model="user.otp" aria-describedby="phoneHelp" class="form-control px-3"
                       required width="100%"/>
              </div>
              <div class="mb-3 d-flex flex-column justify-content-center">
                <button v-if="loading" class="btn btn-dark custom-login-btns" disabled type="button">
                  <span aria-hidden="true" class="spinner-grow spinner-grow-sm" role="status"></span>
                  <span class="sr-only">Loading...</span>
                </button>
                <button v-else-if="showOtpModal" :disabled="!termsAgreed" class="btn btn-dark custom-login-btns"
                        type="submit">
                  Submit
                </button>
                <button v-else :disabled="!termsAgreed" class="btn btn-dark custom-login-btns"
                        type="submit">
                  Sign In
                </button>
                <div v-if="!showOtpModal" class="or mt-3"> OR</div>
                <button v-if="loading" class="btn btn-primary custom-login-btns" disabled type="button">
                  <span aria-hidden="true" class="spinner-grow spinner-grow-sm" role="status"></span>
                  <span class="sr-only">Loading...</span>
                </button>
                <button v-else-if="!showOtpModal" :disabled="!termsAgreed"
                        class="btn btn-primary mt-3 custom-login-btns"
                        type="button" @click="keycloakVerify">
                  Sign In With SSO
                </button>
                <p class="mt-5 text-center">
                  Operation & Maintenance by Computer Network Systems Ltd. CNS
                  &copy; {{ year }}
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {notify} from "@kyvg/vue3-notification";
import axios from 'axios';
import systemSettingsService from "@/services/system-settings.service";
import Config from '@/config/index';
import authService from "@/services/auth.service";

export default {
  name: "LoginPage",
  data() {
    return {
      isOtpValidated: false,
      tempUserData: {},
      imageBasePath: null,
      showPassword: false,
      submitted: false,
      emailBlurred: false,
      passwordBlurred: false,
      useLoginOtp: true,
      user: {
        userId: "",
        password: "",
        otp: "",
      },
      loading: false,
      year: new Date().getFullYear(),
      message: sessionStorage.getItem("message"),
      companyName: "IDRA",
      companyDescription: "Insurance Development and Regulatory Authority",
      companyLogoUrl: null,
      termsAgreed: false,
      companyFullName: "",
      ssoLoggingLoading: false,
      currentDate: new Date().toISOString().split('T')[0],
      showOtpModal: false,
      otpPhoneMessage: null,
    };
  },
  mounted() {
    if (this.$route.query.code) {
      const callbackParams = {
        session_state: this.$route.query.session_state,
        code: this.$route.query.code,
      }
      this.handleSsoLoginNew(callbackParams);
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  async created() {
    this.imageBasePath = Config.apiFileBasePath;
    await this.getSystemSettings();
  },
  methods: {
    async getSystemSettings() {
      this.loading = true;
      var response;
      try {
        response = await systemSettingsService.getSystemSettingsWithoutAuth();
        if (response.data) {
          const adminCmsLogoObj = response.data.find(item => item.system_key === "login_page_logo");
          this.companyLogoUrl = adminCmsLogoObj ? adminCmsLogoObj.value : null;
          const company_short_name_obj = response.data.find(item => item.system_key === "company_short_name");
          this.companyName = company_short_name_obj ? company_short_name_obj.value : null;
          const company_desc_obj = response.data.find(item => item.system_key === "company_description");
          this.companyDescription = company_desc_obj ? company_desc_obj.value : null;
          const company_name_obj = response.data.find(item => item.system_key === "company_name");
          this.companyFullName = company_name_obj ? company_name_obj.value : null;
          const text_editor_token_obj = response.data.find(item => item.system_key === "text_editor_token");
          const token = text_editor_token_obj ? text_editor_token_obj.value : null;
          const carrer_api_url_obj = response.data.find(item => item.system_key === "carrer_api_url");
          const carrer_api_url = carrer_api_url_obj ? carrer_api_url_obj.value : null;

          const useLoginOtpObject = response.data.find(item => item.system_key === "use_login_otp");
          this.useLoginOtp = useLoginOtpObject ? useLoginOtpObject.value === 'Y' : false;
          localStorage.setItem('text_editor_token', token);
          localStorage.setItem('carrer_api_url', carrer_api_url);
        } else {
          notify({
            type: 'error',
            title: 'Error',
            text: "Something went wrong",
          });
        }
      } catch (error) {
        this.loading = false;
        notify({
          type: 'error',
          title: 'Error',
          text: error,
        });
      }
      this.loading = false;
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    validate: function () {
      this.emailBlurred = true;
      this.passwordBlurred = true;
      if (this.validEmail(this.email) && this.validPassword(this.password)) {
        this.valid = true;
      }
    },

    validEmail: function (email) {
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      if (re.test(email.toLowerCase())) {
        return true;
      }
    },

    validPassword: function (password) {
      if (password.length > 7) {
        return true;
      }
    },

    submit: function () {
      this.validate();
      if (this.valid) {
        this.submitted = true;
      }
    },
    async handleLogin1() {
      try {
        if (this.showOtpModal) {
          // if (this.user.userId === "" || this.user.userId == null) {
          //   notify({
          //     type: "error",
          //     title: "User ID",
          //     text: "Please enter a valid User ID",
          //   });
          //   return;
          // } else if (this.user.password === "" || this.user.password == null) {
          //   notify({
          //     type: "error",
          //     title: "Password",
          //     text: "Please enter a valid Password",
          //   });
          //   return;
          // } else

          if (this.user.otp === "" || this.user.otp == null) {
            notify({
              type: "error",
              title: "OTP",
              text: "Please enter a valid OTP",
            });
            return;
          }
          this.loading = true;
          this.message = "";
          sessionStorage.removeItem("message");
          sessionStorage.removeItem("cnsBankCPT");
          const otpPayload = {
            otp: this.user.otp,
            user_id: this.tempUserData.data.user_id,
          }
          const otpValidationResponse = await authService.validateLoginOTP(otpPayload)
          this.loading = false;
          if (otpValidationResponse.messageCode === 1) {
            await this.loginNextPage()
          } else {
            notify({
              type: "error",
              title: "Login",
              text: otpValidationResponse.message,
            });
          }
        } else {
          if (this.user.userId === "" || this.user.userId == null) {
            notify({
              type: "error",
              title: "User ID",
              text: "Please enter a valid User ID",
            });
            return;
          } else if (this.user.password === "" || this.user.password == null) {
            notify({
              type: "error",
              title: "Password",
              text: "Please enter a valid Password",
            });
            return;
          }

          this.loading = true;
          const response = await authService.loginNew(this.user);
          this.loading = false;
          if (response.status === true) {
            this.tempUserData = response;

            if (!this.useLoginOtp) {
              await this.loginNextPage()
              return
            }
            const payload = {
              user_id: this.user.userId,
            }
            const otpResponse = await authService.sendForOTP(payload);
            this.loading = false;
            this.otpPhoneMessage = null;
            if (otpResponse.messageCode === 1) {
              this.showOtpModal = true;
              notify({
                type: "success",
                title: "OTP",
                text: otpResponse.message,
              });
              this.otpPhoneMessage = otpResponse.message;
            } else {
              // console.log("no otp ")
              notify({
                type: "error",
                title: "OTP",
                text: response.message,
                // text: "My message",

              });
            }
          } else {
            this.loading = false;
            notify({
              type: "error",
              title: "Login",
              text: response.message,
            });
          }
        }
      } catch (e) {
        this.loading = false;
        console.log(e)
      }
    },

    async loginNextPage() {
      sessionStorage.setItem("user", JSON.stringify(this.tempUserData));
      localStorage.setItem("user", JSON.stringify(this.tempUserData));
      sessionStorage.removeItem("firstLogin");
      sessionStorage.removeItem("firstLoginMessage");
      if (this.tempUserData.data.password_expiry_date == null ||
          (new Date(this.currentDate) < new Date(this.tempUserData.data.password_expiry_date))) {
        await this.$router.push("/dashboard");
      } else {
        await this.$router.push("/changePassword");
      }
      notify({
        type: "success",
        title: "Authorization",
        text: "USER SIGNED IN SUCCESSFULLY!",
      });
    },
    async keycloakVerify() {
      this.loading = true;
      const url = await axios.get(Config.apiBasePath + "/auth/sso-login");

      this.loading = false;
      window.location.href = url.data;
    },
    async handleSsoLoginNew(callbackParams) {
      try {
        this.ssoLoggingLoading = true;
        this.message = "";
        sessionStorage.removeItem("message");
        sessionStorage.removeItem("cnsBankCPT");
        const ssoResponse = await authService.ssoLoginNew(callbackParams);
        this.ssoLoggingLoading = false;
        if (ssoResponse.code == 1) {
          this.tempUserData = ssoResponse;
          this.termsAgreed = true;

          if (!this.useLoginOtp) {
            await this.loginNextPage()
            return
          }
          const payload = {
            user_id: ssoResponse.data.user_id,
          }
          this.loading = true;
          const response = await authService.sendForOTP(payload);
          this.loading = false;
          if (response.messageCode === 1) {
            this.showOtpModal = true;
            this.isOtpValidated = true;
            notify({
              type: "success",
              title: "OTP",
              text: response.message,
            });
          } else {
            notify({
              type: "error",
              title: "OTP",
              text: response.message,
            });
            await new Promise(resolve => setTimeout(resolve, 2000));
            await authService.ssoLogout(this.tempUserData.data.id_token, this.tempUserData.token.token);

          }
        }
      } catch (e) {
        this.ssoLoggingLoading = false;
        console.log(e)
      }

      // sessionStorage.setItem("user", JSON.stringify(this.tempUserData));
      // localStorage.setItem("user", JSON.stringify(this.tempUserData));
      // sessionStorage.removeItem("firstLogin");
      // sessionStorage.removeItem("firstLoginMessage");
    },
  },
};
</script>

<style>
.card {
  border: none;
  height: 390px;
}

.forms-inputs {
  position: relative;
}

.forms-inputs span {
  position: absolute;
  top: -18px;
  left: 10px;
  background-color: #fff;
  padding: 5px 10px;
  font-size: 15px;
  color: #313242;
}

.forms-inputs input {
  height: 50px;
  border: 2px solid #eee;
}

.forms-inputs input:focus {
  box-shadow: none;
  outline: none;
  border: 2px solid #000;
}

.btn {
  height: 50px;
}

.success-data {
  display: flex;
  flex-direction: column;
}

.bxs-badge-check {
  font-size: 90px;
}

.bg-dark {
  background-color: #1b1e21;
}

div.background {
  background: linear-gradient(rgba(0, 0, 0, 0.527), rgba(0, 0, 0, 0.5)), url(../assets/insurance_pen.jpg);
  border: 1px solid black;
  height: 100%;
  width: 100%;
  /* border-top-right-radius: 10px;
  border-bottom-right-radius: 10px; */
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

div.transbox {
  margin: 30px;
  margin-top: 10%;
  background-color: #E7E7E7;
  border: 1px solid black;
  opacity: 0.8;
  text-align: center;
}

div.transbox p {
  margin: 5%;
  font-weight: bold;
  color: rgb(0, 0, 0);
  font-size: 25px;
  opacity: 1;
}

.custom-login-btns {
  height: 6vh !important;
  width: 50%;
  align-self: center;
}

.or {
  display: flex;
  justify-content: center;
  align-items: center;
  color: grey;
}

.or:after,
.or:before {
  content: "";
  display: block;
  background: grey;
  width: 20%;
  height: 1px;
  margin: 0 10px;
}
</style>
